import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const troGiupMenu: NavMenu = {
  title: 'Trợ giúp',
  items: [
    {
      title: 'Video hướng dẫn sử dụng các tính năng',
      icon: <AritoIcon icon={373} />,
      group: 0
    },
    {
      title: 'Thông tin sản phẩm',
      icon: <AritoIcon icon={22} />,
      group: 1
    }
  ]
};
